import React, {PureComponent} from "react"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"

import {ReduxState} from "@irati/store/types"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import AuthStream from "@irati/auth/streams/auth"
import UnauthedStream from "@irati/auth/streams/unauthed"
import ObserveWithPriority from "@irati/auth/helpers/auth/ObserveWithPriority"

import {UnAuthed, Auth} from "@irati/auth/types"
import * as PropTypes from "prop-types"
import HeaderDesktop from "./desktop/HeaderDesktop"
import SecondaryNavDesktop from "./desktop/SecondaryNav"
import HeaderMobile from "./mobile/HeaderMobile"
import BrandLine from "./shared/BrandLine"

const idNamespace = "header"

interface Props {
  isMobile: boolean
  location: {
    pathname: string
  }
}

interface State {
  auth?: Auth | UnAuthed
  isLoggedIn: boolean
}

class Header extends PureComponent<Props, State> {
  stream: ZenObservable.Subscription | null = null

  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    isLoggedIn: false
  }

  componentDidMount() {
    this.stream = new ObserveWithPriority<Auth | UnAuthed>({streams: [AuthStream, UnauthedStream], key: "branding"}).subscribe((auth) => {
      const isLoggedIn = authentication.isLoggedIn()
      if (auth && auth.branding) {
        this.setState({auth, isLoggedIn})
      } else {
        this.setState({auth: undefined, isLoggedIn})
      }
    })
  }

  componentWillUnmount() {
    if (this.stream) {
      this.stream.unsubscribe()
    }
  }

  render() {
    const {isMobile, location} = this.props
    const {auth, isLoggedIn} = this.state
    const {appPath, apps: contextApps} = this.context
    const {ADMIN} = contextApps
    const isAdminSection = appPath === ADMIN

    if (!auth || !isLoggedIn) {
      return null
    }

    const color = auth.branding.primaryColour

    return (
      <>
        {/* Main Header */}
        {!isMobile && <HeaderDesktop id={id("desktop", idNamespace)} auth={auth} />}
        {isMobile && <HeaderMobile togglePanel={this.togglePanel} id={id("mobile", idNamespace)} auth={auth} />}
        {isLoggedIn && isAdminSection && <BrandLine brandColor={color} isMobile={isMobile} id={id("brandLine", idNamespace)} />}
        {/* Secondary Nav */}
        {!isMobile && <SecondaryNavDesktop brandColor={color} pathname={location.pathname} />}
      </>
    )
  }
}

const mapStateToProps = (state: ReduxState) => {
  return {
    isMobile: state.mq.lessThan.medium
  }
}

export default withRouter(connect(mapStateToProps)(Header))
